const calculateOffsetTop = (element: HTMLElement | null): number => {
  if (!element) return 0;
  return (element?.offsetTop ?? 0) + calculateOffsetTop(element?.offsetParent as HTMLElement);
};

export default calculateOffsetTop;
